// Reveals its region once it scrolls into view; CSS in config/styles.css owns the motion.
class RevealElement extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion || this.hasAttribute('immediate') || !('IntersectionObserver' in window)) {
      this.setAttribute('data-revealed', '');
      return;
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          this.setAttribute('data-revealed', '');
          this.#observer?.disconnect();
          this.#observer = null;
        }
      },
      { rootMargin: '0px 0px -12% 0px', threshold: 0.05 },
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }
}

if (!customElements.get('s-reveal')) {
  customElements.define('s-reveal', RevealElement);
}
